export class CasasDecimaisRequest {
  casasDecimaisPreco: number;
  casasDecimaisQuantidade: number;
}